import axios from "axios";
import { TOKEN_DATA, TOKEN_DATA_SOURCE } from "@/config/tokenData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Token data interface — identical shape from config and API:
 * { status: "LAUNCH_PENDING" | "LIVE", currentMarketCap, currentPrice, holders, volume24h, tokenAddress, source, updatedAt }
 * "config" → static pre-launch zeros from config/tokenData.js (no market API call).
 * "api"    → GET /api/token (backend Solana provider) on launch day.
 */
export const getTokenData = async () => {
  if (TOKEN_DATA_SOURCE === "config") return { ...TOKEN_DATA, source: "config", updatedAt: null };
  const { data } = await axios.get(`${API}/token`, { timeout: 8000 });
  return data;
};
